var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultCustomerProfile64(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E4EFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.1111,
    stroke: "#202020",
    strokeOpacity: 0.03,
    strokeWidth: 1.77778
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3392 16C37.8656 16 41.9392 20.0704 41.9392 25.6C41.9392 31.1296 37.8656 35.2 32.3392 35.2C26.816 35.2 22.7392 31.1296 22.7392 25.6C22.7392 20.0704 26.816 16 32.3392 16ZM16 47.2704C18.8704 43.0464 23.6576 40.2304 29.1392 40.2304H35.5392C41.024 40.2304 45.808 43.0464 48.6784 47.2704C44.5888 51.648 38.7872 54.4 32.3392 54.4C25.8912 54.4 20.0896 51.648 16 47.2704Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCustomerProfile64);
export default __webpack_public_path__ + "static/media/default_customer_profile_64.571efa5c4228cb78407c7655c17957bf.svg";
export { ForwardRef as ReactComponent };